var _defs, _rect, _rect2, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzVideoHeroOpportunityMatchPoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 675,
    viewBox: "0 0 1200 675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz opportunity match video poster") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tlvhPosterBase",
    x1: 0,
    y1: 0,
    x2: 1200,
    y2: 675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07152A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020816"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tlvhPosterGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(827 315) rotate(90) scale(280)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#087CFF",
    stopOpacity: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tlvhPosterRing",
    x1: 680,
    y1: 170,
    x2: 960,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6BD7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3885"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tlvhPosterShadow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 22,
    floodColor: "#000A18",
    floodOpacity: 0.52
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#tlvhPosterBase)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#tlvhPosterGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    stroke: "#4E9DFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 825,
    cy: 315,
    r: 205
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 825,
    cy: 315,
    r: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 584,
    y1: 315,
    x2: 1066,
    y2: 315
  }), /*#__PURE__*/React.createElement("line", {
    x1: 825,
    y1: 84,
    x2: 825,
    y2: 546
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 69,
    width: 430,
    height: 537,
    rx: 26,
    fill: "#FFFFFF",
    fillOpacity: 0.98,
    stroke: "#BCD7F7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 122,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 31,
    fontWeight: 760
  }, "Opportunity match"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 154,
    fill: "#657892",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16
  }, "Ranked. Explained. Interview-ready."), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 188,
    width: 368,
    height: 320,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#D8E4F3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 188,
    width: 368,
    height: 74,
    rx: 17,
    fill: "#F2F8FF",
    stroke: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 231,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 700
  }, "1"), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 225,
    r: 23,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 171,
    y: 231,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 750
  }, "AB"), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 213,
    width: 142,
    height: 10,
    rx: 5,
    fill: "#E0E8F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 213,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 232,
    width: 95,
    height: 7,
    rx: 3.5,
    fill: "#D5E0EF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 437,
    y: 233,
    textAnchor: "end",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 780
  }, "92%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 74)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 231,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 700
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 225,
    r: 23,
    fill: "#DFE8F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 171,
    y: 231,
    textAnchor: "middle",
    fill: "#2E405B",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 750
  }, "CD"), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 213,
    width: 142,
    height: 10,
    rx: 5,
    fill: "#E0E8F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 213,
    width: 82,
    height: 10,
    rx: 5,
    fill: "#9CADC3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 232,
    width: 95,
    height: 7,
    rx: 3.5,
    fill: "#D5E0EF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 437,
    y: 233,
    textAnchor: "end",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 780
  }, "78%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 148)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 231,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 700
  }, "3"), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 225,
    r: 23,
    fill: "#DFE8F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 171,
    y: 231,
    textAnchor: "middle",
    fill: "#2E405B",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 750
  }, "EF"), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 213,
    width: 142,
    height: 10,
    rx: 5,
    fill: "#E0E8F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 213,
    width: 75,
    height: 10,
    rx: 5,
    fill: "#9CADC3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 232,
    width: 95,
    height: 7,
    rx: 3.5,
    fill: "#D5E0EF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 437,
    y: 233,
    textAnchor: "end",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 780
  }, "71%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 222)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 123,
    y: 231,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17,
    fontWeight: 700
  }, "4"), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 225,
    r: 23,
    fill: "#DFE8F4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 171,
    y: 231,
    textAnchor: "middle",
    fill: "#2E405B",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 750
  }, "GH"), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 213,
    width: 142,
    height: 10,
    rx: 5,
    fill: "#E0E8F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 213,
    width: 68,
    height: 10,
    rx: 5,
    fill: "#9CADC3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 232,
    width: 95,
    height: 7,
    rx: 3.5,
    fill: "#D5E0EF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 437,
    y: 233,
    textAnchor: "end",
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 780
  }, "64%")), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 533,
    width: 368,
    height: 44,
    rx: 12,
    fill: "#F6F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 555h13m-5-5 5 5-5 5",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 153,
    y: 561,
    fill: "#50647F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Evidence behind every rank"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 121,
    width: 101,
    height: 34,
    rx: 10,
    fill: "#FF3885"
  }), /*#__PURE__*/React.createElement("text", {
    x: 826.5,
    y: 144,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 750
  }, "Top match"), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 315,
    r: 145,
    fill: "#FFFFFF",
    fillOpacity: 0.05,
    stroke: "url(#tlvhPosterRing)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 315,
    r: 113,
    fill: "#07152A",
    stroke: "#77CCFF",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 826,
    cy: 242,
    r: 30,
    fill: "#087CFF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 251,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 750
  }, "AB"), /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 301,
    fill: "#C1CDDC",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15
  }, "Suitability score"), /*#__PURE__*/React.createElement("text", {
    x: 826,
    y: 372,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 72,
    fontWeight: 820
  }, "92%"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(625 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 528,
    r: 23,
    fill: "#0B2342",
    stroke: "#357EC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 519-6 528l11 9",
    fill: "none",
    stroke: "#80C4FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 570,
    fill: "#C1CDDC",
    fontSize: 13,
    fontWeight: 700
  }, "Technical"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 588,
    fill: "#C1CDDC",
    fontSize: 13,
    fontWeight: 700
  }, "competency"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 620,
    fill: "#80C4FF",
    fontSize: 19,
    fontWeight: 800
  }, "94%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(826 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 528,
    r: 23,
    fill: "#35152A",
    stroke: "#A72D60"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 523,
    r: 5,
    fill: "none",
    stroke: "#FF85B2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 540c1-9 17-9 18 0",
    fill: "none",
    stroke: "#FF85B2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 570,
    fill: "#C1CDDC",
    fontSize: 13,
    fontWeight: 700
  }, "Workplace"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 588,
    fill: "#C1CDDC",
    fontSize: 13,
    fontWeight: 700
  }, "awareness"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 620,
    fill: "#FF85B2",
    fontSize: 19,
    fontWeight: 800
  }, "89%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1025 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 528,
    r: 23,
    fill: "#0B2342",
    stroke: "#357EC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 516l8 4v8c0 6-3 10-8 13-5-3-8-7-8-13v-8l8-4Z",
    fill: "none",
    stroke: "#80C4FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 570,
    fill: "#C1CDDC",
    fontSize: 13,
    fontWeight: 700
  }, "Profile"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 588,
    fill: "#C1CDDC",
    fontSize: 13,
    fontWeight: 700
  }, "validity"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 620,
    fill: "#80C4FF",
    fontSize: 19,
    fontWeight: 800
  }, "93%")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzVideoHeroOpportunityMatchPoster);
export default __webpack_public_path__ + "static/media/talentlenz-video-hero-opportunity-match-poster.9222c1d06bfd5b84077ea9cbf689c03d.svg";
export { ForwardRef as ReactComponent };